View = require 'view'

module.exports = class WarningBannerView extends View
  className: 'header-banner mod-warning'



// WEBPACK FOOTER //
// ./app/scripts/views/header/warning-banner-view.coffee